export default {
  state: {
    statisticsData: [],
    statisticsByVersion: []
  },
  getters: {
    getStatisticsData(state) {
      return state.statisticsData;
    },
    getStatisticsByVersion(state) {
      return state.statisticsByVersion;
    }
  },
  mutations: {
    setStatisticsData(state, data) {
      state.statisticsData = data;
    },
    setStatisticsByVersion(state, data) {
      state.statisticsByVersion = data
    },
  },
  actions: {
    async fetchStatisticsData({ dispatch, commit }, { softwareCode }) {
      const response = await dispatch('apiRequest', {
        endpoint: `statistics/${softwareCode}`,
        method: 'GET'
      })
      const responseData = await response.json()
      commit('setStatisticsData', responseData)
    },
    async fetchStatisticsByVersion({ dispatch, commit }, { softwareCode, softwareVersion }) {
      const response = await dispatch('apiRequest', {
        endpoint: `statistics/${softwareCode}/${softwareVersion}`,
        method: 'GET'
      })
      const responseData = await response.json()
      commit('setStatisticsByVersion', responseData)
    },
  }
}
